var userAgent = require('../../useragent');

module.exports = function(cb) {
  var wrapper = function(value) {
    return function() {
      cb(value);
    };
  };

  var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
  if (fs) {
    fs(window.TEMPORARY, 100, wrapper(false), wrapper(true));
  } else if (userAgent.match('Safari')) {
    try {
      window.localStorage.setItem('test', 1);
      cb(false);
      window.localStorage.removeItem('test');
    } catch(ex) {
      cb(true);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/incognito/webkit.js
// module id = 22
// module chunks = 1 3